import React, { Fragment, useState, useEffect } from 'react';
import { Card, Spin, Table, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { formatCurrency } from '../../../helpers/utils';
import SnapshotService from '../services';
const ReceivablesByAge = () => {
  const [data, setData] = useState({
    due_now: 0,
    days_0_30: 0,
    days_30_60: 0,
    days_60_90: 0,
    days_over_90: 0,
    total: 0
  });
  const [currency, setCurrency] = useState({ currency_symbol: '$', currency_code: 'USD' });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    SnapshotService.getReceivablesByAge()
      .then((response) => {
        if (response.data?.success) {
          setData(response.data.data);
          setCurrency(response.data.data.currency || { currency_symbol: '$', currency_code: 'USD' });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching receivables:', error);
        setIsLoading(false);
      });
  };

  const columns = [
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      render: (amount) => formatCurrency(amount, currency.currency_symbol),
    },
  ];

  const tableData = [
    {
      key: 'due_now',
      age: 'Due now',
      amount: data.due_now,
    },
    {
      key: 'days_0_30',
      age: '0-30 days',
      amount: data.days_0_30,
    },
    {
      key: 'days_30_60',
      age: '30-60 days',
      amount: data.days_30_60,
    },
    {
      key: 'days_60_90',
      age: '60-90 days',
      amount: data.days_60_90,
    },
    {
      key: 'days_over_90',
      age: '> 90 days',
      amount: data.days_over_90,
    },
  ];

  if (isLoading) {
    return (

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <Spin indicator={<LoadingOutlined spin />} />
        </div>
    );
  }
  const { Text } = Typography;
  return (
// Title: Money owed to me
<Fragment>
  <Text className='mb-0' strong>Money owed to me</Text>
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        size="small"
        showHeader={false}
        summary={(pageData) => {
          const total = data.total;
          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                  <strong>Total</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  <strong>{formatCurrency(total, currency.currency_symbol)}</strong>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
</Fragment>
  );
};

export default ReceivablesByAge;

